import { render, staticRenderFns } from "./ship-in-list.vue?vue&type=template&id=2076fe78&scoped=true"
import script from "./ship-in-list.vue?vue&type=script&lang=js"
export * from "./ship-in-list.vue?vue&type=script&lang=js"
import style0 from "./ship-in-list.vue?vue&type=style&index=0&id=2076fe78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076fe78",
  null
  
)

export default component.exports